import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './Redux/Store';
import { DndProvider } from 'react-dnd';
import Backend from 'react-dnd-html5-backend';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import MainPage from './MainPage';
import Crear from './Crear';
import Articulos from './Articulos';
import Meta from './Meta';
import Admin from './Admin';
import './index.css';
import ContactPage from './contact';
import AnalyticsWrapper from './AnalyticsWrapper';

ReactDOM.render(
  <Provider store={store}>
    <DndProvider backend={Backend}>
      <Router>
        <AnalyticsWrapper>
          <Switch>
            <Route exact path="/" component={MainPage} />
            <Route path="/crear" component={Crear} />
            <Route path="/articulos" component={Articulos} />
            <Route path="/meta" component={Meta} />
            <Route path="/contact" component={ContactPage} />
            <Route path="/admin" component={Admin} />
            <Redirect from="/home" to="/crear" />
          </Switch>
        </AnalyticsWrapper>
      </Router>
    </DndProvider>
  </Provider>,
  document.getElementById('root')
);

